import React from 'react';
import styled from 'styled-components';

export default function FilterInput({
	value,
	inputId,
	onChange,
	width = 254,
	placeholder,
}) {
	return (
		<Container className='filter-input' width={width}>
			<Input
				type='text'
				id={inputId}
				name={inputId}
				value={value}
				onChange={onChange}
				placeholder={placeholder}
			/>
		</Container>
	);
}

const Container = styled.div`
	border: 1px solid var(--button-border-color);
	border-radius: 5px;
	padding: 4px 17px;
	width: ${props => props.width}px;
`;

const Input = styled.input`
	color: var(--third-text-color);
	background: none;
	border: none;
	width: 100%;
	font-family: 'NotoSansMd';
	font-weight: 500;
	font-size: 12px;
`;
